import React from "react";
import { Form, Input, message, Modal, Checkbox} from "antd";
import { TruckFilter } from "../../../../filters/TruckType";
import { TruckJobFilter } from "../../../../filters/TruckJobs";
import { TruckOwnershipFilter } from "../../../../filters/TruckOwnership";
import { TruckPost } from "../../../../models/truck";
import { TruckGet, TruckUpdate } from "../../../../models/truck"
const FormItem = Form.Item;
const { TextArea } = Input;

class AddUpdateTruckForm extends React.Component {
  state = {};
  handlePopupAfterAddUpdate = () => {
    this.props.fetch();
    this.props.setModelVisible()
  };

  componentDidUpdate(prevProps) {
    const { visible, row_id } = this.props;
    if (visible && row_id && (visible !== prevProps.visible && row_id !== prevProps.row_id)) {
      this.fetchData(row_id);
    }
  }
  componentDidMount() {
    if (this.props.onRef) {
      this.props.onRef(this)
    }
  }
  componentWillUnmount() {
    if (this.props.onRef)
      this.props.onRef(null)
  }

  fetchData(row_id) {
    let form = this.props.form;
    TruckGet(row_id)
      .then(response => {
        form.setFieldsValue({
          type: response.data.type,
          description: response.data.description,
          truck_id: response.data.truck_id,
          active: response.data.active,
        })
        this.truck.handleChange({
          key: response.data.type.id,
          label: response.data.type.type_name
        })
        this.jobs.handleChange(response.data.jobs.map(item => {
          return { key: item.id, label: item.name }
        }))
          this.ownership.handleChange({
          key: response.data.owner.id,
          label: response.data.owner.name
        })
      })
  }

  handleUpdate(row_id) {
    this.props.form.validateFields((err, values) => {
      if (!err) {
        TruckUpdate(this.props.row_id, values)
          .then(response => {
            message.success("Truck updated successfully");
            this.handlePopupAfterAddUpdate();
          });
      }
    });
  }
  handleCreate = (e) => {
    const form = this.props.form;
    form.validateFields((err, values) => {
      if (!err) {
        TruckPost(values)
          .then(response => {
            this.setState({
              visible: false,
              value: { key: response.id, label: response.truck_id }
            });
            message.success('Truck created successfully');
            form.resetFields();
            this.handlePopupAfterAddUpdate()
          });
      }
    });
  };
  render() {
    const { getFieldDecorator } = this.props.form;
    const { fields } = this.state;
    const { visible, row_id } = this.props;
    return (
      <Modal title={row_id ? "Update Truck" : "Add Truck"} okText={row_id ? "Update Truck" : "Add Truck"} centered width={"60%"} visible={visible} onOk={row_id ? () => this.handleUpdate(row_id) : this.handleCreate} onCancel={() => this.props.setModelVisible()} destroyOnClose={true}>
        <div className="col-xs-12 paddingZ add-item-inner floating-form">
          <Form>
            <div className="row">
              <div className="floating-label">
                <FormItem label="Truck Id">
                  {getFieldDecorator('truck_id', {
                    rules: [{ required: true, message: 'Please enter truck id' }],
                  })(<Input placeholder="Enter Truck ID" />)}
                </FormItem>
              </div>
              <div className="floating-label">
                <FormItem label="Truck Type">
                  {getFieldDecorator('type', {
                    rules: [{ required: true, message: 'Please choose truck type' }],
                  })(<TruckFilter onRef={ref => (this.truck = ref)} {...fields} single={true} />)}
                </FormItem>
              </div>
              <div className="floating-label">
                <FormItem label="Jobs">
                  {getFieldDecorator('jobs', {
                    rules: [{ required: true, message: 'Please choose truck capability' }],
                  })(<TruckJobFilter onRef={ref => (this.jobs = ref)} {...fields} />)}
                </FormItem>
              </div>
              <div className="floating-label">
                <FormItem label="Owner">
                  {getFieldDecorator('owner', {
                    rules: [{ required: true, message: 'Please choose truck ownership' }],
                  })(<TruckOwnershipFilter onRef={ref => (this.ownership = ref)} {...fields} />)}
                </FormItem>
              </div>
              <div className="floating-label">
                <FormItem label="Desciption">
                  {getFieldDecorator('description', {
                    rules: [{ required: true, message: 'Please choose specification' }],
                  })(<TextArea placeholder="Enter Truck Specification" rows={3} />)}
                </FormItem>
              </div>
                <div className="floating-label">
                <FormItem label="Active">
                  {getFieldDecorator('active', {
                    initialValue: true,
                      valuePropName: 'checked',
                  })(<Checkbox>Active</Checkbox>)}
                </FormItem>
              </div>
            </div>
          </Form>
        </div>
      </Modal>
    )
  }
}

export const AddUpdateTruck = Form.create()(AddUpdateTruckForm);


// WEBPACK FOOTER //
// ./src/pages/analytics/add_truck/popup/AddUpdateTruck.jsx